import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { Icon } from "../icon";
import { Text } from "../text";
import { useTranslation } from "../i18n";
import { useConfig } from "../_util/config-context";
export var ErrorTip = React.forwardRef(function ErrorTip(props, ref) {
    var classPrefix = useConfig().classPrefix;
    var t = useTranslation();
    var _a = props.errorText, errorText = _a === void 0 ? t.loadErrorText : _a, _b = props.retryText, retryText = _b === void 0 ? t.loadRetryText : _b, onRetry = props.onRetry, hideIcon = props.hideIcon, className = props.className, restProps = __rest(props, ["errorText", "retryText", "onRetry", "hideIcon", "className"]);
    return (React.createElement("span", __assign({ ref: ref, className: classNames(classPrefix + "-action-state", className) }, restProps),
        !hideIcon && React.createElement(Icon, { type: "error", className: classPrefix + "-mr-2n" }),
        typeof errorText === "string" ? (React.createElement(Text, { className: classPrefix + "-action-state__text", theme: "danger", title: errorText }, errorText)) : (errorText),
        onRetry && (React.createElement(React.Fragment, null,
            " ",
            React.createElement("a", { className: classPrefix + "-action-state__text " + classPrefix + "-ml-1n", onClick: onRetry }, retryText)))));
});
ErrorTip.displayName = "ErrorTip";
//# sourceMappingURL=ErrorTip.js.map